import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Progress
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { check, updateGeologiaShapeCavernasFile } from "../../Services/GeologiaShapeFileCavernasService";
import { checkKey } from "../../Services/SecurityService";
//import {  } from "../../Services/GeometryShapes";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";
import shp from "shpjs";

let notificationTC = null;

let estadosSize = [];
let geologias2 = [];
let shapeFile = [];
let totalGeologias = 0;
let contGeologias = 0;
const LIMITE = 200;


const rootGeologias = `${process.env.PUBLIC_URL}/19/shp/cavernas/`;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      carregarShapes: true,
      next: true,
      clicked: false,

      canceled: false,

      processingStatus: 0,
      processingStatusInfo: 1,
      tempoRestante: '',

      estados: {},
      files: [],
      geologies: [],

      data: {
        geologiaShapeFileCavernas: null,
        geometryCavernasList: null
      }
    };
    check();

    this.loadShapes = this.loadShapes.bind(this);
    this.loadZipfile = this.loadZipfile.bind(this);
    this.process = this.process.bind(this);
  }

  process(requestList, index, length){
    let inicio = performance.now();
    let fim = 0;
    let diff = 0;
    let tempo = 0;
    let tempoRestante = "";
    
    updateGeologiaShapeCavernasFile(requestList[index])
    .then(obj => {
      if(obj !== null && obj !== undefined){
        if(obj.erros === null || obj.erros === undefined || obj.erros.length === 0){
          contGeologias += requestList[index].cavernasList.length;
          let processingStatus = (contGeologias /  (totalGeologias+1)) * 100;

          fim = performance.now();
          diff = fim - inicio;
          tempo = diff * (((totalGeologias+1)-contGeologias)/LIMITE);
          tempoRestante = util.formatMiliseconds(tempo);

          this.setState({ processingStatus: processingStatus.toFixed(2), tempoRestante });

          if(index === length){
            this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            setTimeout(
              () => this.props.updateTable(false), 
              1000
            );
          }else{
            if(!this.state.canceled){
              this.process(requestList, index+1, length);
            }
          }
          
        }else{
          this.setState({ clicked: false });
        }
      } else {
        this.setState({ clicked: false });
        if(obj.errors === undefined){
          this.show('danger', this.props.t('forms.dataUpdateError'));
        } else {
          this.show('danger', obj.errors[0].defaultMessage);
        }
      }
    });
  }

  handleSubmit(e){
    if(this.state.next){
      this.setEstados();
    }else{
      this.setState({ clicked: true });
      let requestList = [];

      totalGeologias = geologias2.length-1;
      contGeologias = -1;
      while(contGeologias < totalGeologias){
        let request = {
          cavernasList: []
        };
        if(contGeologias < 0){
          contGeologias++;
          request.cavernasList.push(geologias2[contGeologias]);
        }else{
          for(let g = 0; g < LIMITE; g++){
            contGeologias++;
            request.cavernasList.push(geologias2[contGeologias]);
            if(contGeologias + 1 > totalGeologias){
              break;
            }
          }
        }
        requestList.push(request);
      }
      contGeologias = 0;
      this.process(requestList, 0, requestList.length-1);
    }
  }

  getTotalCavesByUF(uf){
    for(let i = 0; i < estadosSize.length; i++){
      if(estadosSize[i].uf === uf){
        return estadosSize[i].total;
      }
    }
    return 0;
  }

  setEstados(){
    //console.log("setEstados");
    if(geologias2 !== null && geologias2 !== undefined && geologias2.length > 0){
      let uf;
      let total = geologias2.length;
      for(let i = 0; i < total; i++){
        uf = geologias2[i].geologiaShapeFileCavernas.name.substring(0,2);
        geologias2[i].geologiaShapeFileCavernas.geometries = this.getTotalCavesByUF(uf);
        if(geologias2[i].geologiaShapeFileCavernas.estado !== null && 
            geologias2[i].geologiaShapeFileCavernas.estado !== undefined && 
            geologias2[i].geologiaShapeFileCavernas.estado.id != null && 
            geologias2[i].geologiaShapeFileCavernas.estado.id != undefined &&
            geologias2[i].geologiaShapeFileCavernas.estado.id > 0){
              geologias2[i].estado = geologias2[i].geologiaShapeFileCavernas.estado;
              geologias2[i].geologiaShapeFileCavernas.estado = geologias2[i].estado;
        }else{
          let estado = this.state.estados.get(uf.toLowerCase());
          //if(estado != null && estado != undefined){
          geologias2[i].estado = estado;
          geologias2[i].geologiaShapeFileCavernas.estado = geologias2[i].estado;
          //}
        }
        let processingStatus = ((i+1) /  total) * 100;
        this.setState({ processingStatus: processingStatus.toFixed(2) });
      }
      setTimeout(
        () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo+1 }), 
        1000
      );
    }
    //console.log(geologias2);
    this.setState({next: false});
  }

  loadShapes(){
    let total = this.state.files.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        this.loadZipfile(this.state.files[i]);

        let processingStatus = ((i+1) /  total) * 100;
        this.setState({ carregarShapes: false, processingStatus: processingStatus.toFixed(2) });
      }
      setTimeout(
        () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo+1 }), 
        1000
      );
    }
  }

  loadZipfile(file) {
    let path = rootGeologias.concat(file.name).concat(".zip");
    
    try {
      shp(path).then(function (shapes) {
        console.log("shapes:");
        console.log(shapes);
        let list = [];
        if(shapes.length != undefined && shapes.length != null && shapes.length > 0){
          list = shapes;
        }else{
          list.push(shapes);
        }
        
        let totalFeatures = 0;
        let filename = "";
        for(let dta = 0; dta < list.length; dta++){
          let data = list[dta];
          filename = data.fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          totalFeatures = data.features.length;

          for(let i = 0; i < totalFeatures; i++){
            let type = data.features[i].geometry.type;
            let coordinatesList = data.features[i].geometry.coordinates;
            let properties = data.features[i].properties;

            let geometry = {
              id: '',
              code: properties.COD_CECAV_,
              codeExterno: properties.CAD_EXTERN,
              name: properties.NOME_C_254,
              cidade: properties.MUNIC_IBGE,
              estado: properties.ESTADO_C_2,
              localidade: properties.LOCALIDADE,
              litologia: properties.LITOLOGIA_,
              classificacao: properties.CLASSIFICA,
              data: properties.DATA_C_254,
              validacao: properties.VALIDA_C_2,
              bibliografia: properties.FONTE_C_25,
              status: "ATIVO",
              deleted: false,
              point: null,
              pointLatLng: null,
              geologiaShapeFileCavernas: null
            };

            if(coordinatesList != null && coordinatesList != undefined && coordinatesList.length > 0){
              if(type === "Point"){
                geometry.pointLatLng = {
                  lat: coordinatesList[1],
                  lng: coordinatesList[0]
                };
              }
            }
            //montou a geologia

            let index = 0;
            let exists = false;
            if(estadosSize.length > 0){
              for(let i = 0; i < estadosSize.length; i++){
                if(estadosSize[i].uf === geometry.estado){
                  estadosSize[i].total++;
                  exists = true;
                  index = i;
                }
              }
            }
            if(!exists){
              estadosSize.push({uf:geometry.estado, total: 1});
              index = estadosSize.length-1;
            }
            
            geometry.geologiaShapeFileCavernas = {
              createdAt: file.createdAt,
              deleted: file.deleted,
              estado: file.estado,
              extension: file.extension,
              id: file.id,
              name: geometry.estado + " - " + filename,
              filename: file.name + ".zip",
              geometries: 0, // será atualizado no set de Estados com a var estadosSize[?].total
              geometriesLidas: 0,
              size: file.size,
              statusLoad: file.statusLoad,
              type: file.type,
              updatedAt: file.updatedAt,
              start: false
            }

            geologias2.push(geometry);
          }
        }
        // console.log("geologias:");
        // console.log(geologias2);
      });
    } catch (err) {
      console.log(err);
    }
  }
  
  loadData(files, estados) {
    if(files !== undefined && files !== null && files.length > 0 &&
        estados !== undefined && estados !== null && estados.size > 0){
        this.setState({ 
          files,
          estados
        }, () => {});
    }
  }

  getPoint(point){
    return point.lng + " " + point.lat;
  }

  componentDidMount() {
    checkKey("MENU_GEOLOGY_SHP_CAVERNAS_PROCESSING");
    
    const { files, estados} = this.props;
    this.loadData(files, estados);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.files !== this.props.files || props.estados !== this.props.estados){
      this.loadData(this.props.files, this.props.estados);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  clear(canceled){
    const data = { ...this.state.data }
    data['geologiaShapeFileCavernas'] =  null;
    data['geometryCavernasList'] =  null;
    this.setState({ 
      data,
      estados: {},
      files: [],
      geologies: [],
      canceled
    }, () => {});
  }

  cancel(event) {
    this.clear(true);
    this.props.updateTable(false);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    const { files, carregarShapes, clicked, processingStatus, processingStatusInfo, tempoRestante } = this.state;

    let geologiaShapeFileCavernas = [];
    if(this.state.next){
      let total = files.length;
      if(total > 0){
        for(let i = 0; i < total; i++){
          geologiaShapeFileCavernas.push(
            <div key={"divshapes_"+i} className='form__form-inline' style={{width: '100%', borderBottom: '1px solid #cccccc'}}>
              <label 
                key={"labelshapes_"+i}
                style={{margin: 0, width: '100%'}}>
                {files[i].name}
              </label>
              <label 
                key={"labelshapes2_"+i}
                style={{margin: 0, }}>
                {t('forms.geologias')}
              </label>
            </div>
          );
        }
      }
    }else{
      let exists = false;
      shapeFile = [];
      let total = geologias2.length;
      let maxSimbs = 20;
      if(total > 0){
        for(let i = 0; i < total; i++){
          if(shapeFile.length === 0){
            let shp = {
              name: geologias2[i].geologiaShapeFileCavernas.name,
              points: [],
              total: 0,
              full: false
            };
            geologias2[i].geologiaShapeFileCavernas.start = true;
            if(geologias2[i].pointLatLng != null){
              shp.points.push("Point (" + this.getPoint(geologias2[i].pointLatLng) + ")");
              shp.total++;
            }
            shapeFile.push(shp);
          }else{
            exists = false;
            for(let j = 0; j < shapeFile.length; j++){
              if(geologias2[i].geologiaShapeFileCavernas.name === shapeFile[j].name){
                exists = true;
                if(shapeFile[j].points.length < maxSimbs){
                  if(geologias2[i].pointLatLng != null){
                    shapeFile[j].points.push("Point (" + this.getPoint(geologias2[i].pointLatLng) + ")");
                    shapeFile[j].total++;
                  }
                  shapeFile[j].points = shapeFile[j].points.sort((a, b) => (a > b) ? 1 : -1);
                }else{
                  if(geologias2[i].pointLatLng != null){
                    shapeFile[j].total++;
                  }
                  if(!shapeFile[j].full){
                    shapeFile[j].points.push("...");
                    shapeFile[j].full = true;
                  }
                }
                break;
              }
            }
            if(!exists){
              let shp = {
                name: geologias2[i].geologiaShapeFileCavernas.name,
                points: [],
                total: 0,
                full: false
              }
              geologias2[i].geologiaShapeFileCavernas.start = true;
              if(geologias2[i].pointLatLng != null){
                shp.points.push("Point (" + this.getPoint(geologias2[i].pointLatLng) + ")");
                shp.total++;
              }
              shapeFile.push(shp);
            }
          }
        }
        
        for(let i = 0; i < shapeFile.length; i++){
          let simbs = [];
          for(let j = 0; j < shapeFile[i].points.length; j++){
            simbs.push(
              <div key={"labelshapesdiv_"+i+"_"+j} className='form__form-inline' 
                style={{width: 'auto', backgroundColor: 'rgb(190 255 190 / 35%)', border: '1px solid', 
                borderColor: 'rgb(36 140 36 / 35%)', paddingLeft: '3px', paddingRight: '3px', marginRight: '10px', marginBottom: '10px' }}>
                <label 
                  key={"labelshapes2_"+i}
                  style={{margin: 0, }}>
                  {shapeFile[i].points[j]}
                </label>
              </div>
            );
          }

          geologiaShapeFileCavernas.push(
            <div key={"divshapes_"+i} className="form__form-inline" 
                  style={{height: 'auto', width: '100%', borderBottom: '1px solid #cccccc'}}>
              <label 
                key={"labelshapes_"+i}
                style={{margin: 0, width: '100%'}}>
                {shapeFile[i].name + ": " + shapeFile[i].total + " Cavernas"}
              </label>
              <div key={"divshapes_simbs"+i} className="form__form-group-field" 
                  style={{width: '100%', display: 'flow-root', flexWrap: 'wrap'}}>
                    {simbs}
              </div>
            </div>
          );
        }
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.toProcess')}</h3>
            </div>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.processingStatus') + " - " + t('forms.processingStatusInfo_'+processingStatusInfo) + ": " + processingStatus + " % (" + t('forms.timeLeft') + ": " + tempoRestante + ")"} 
                </span>
                <div key="div1" className="progress-wrap progress-wrap--big">
                  <Progress key="progress1" animated value={processingStatus} />
                </div>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px'}}>
                  
                  {geologiaShapeFileCavernas}

                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit"
                  onClick={e => this.loadShapes()}
                  disabled={!carregarShapes}>
                  {t('forms.loadShapes')}
                </Button>
                <Button color="primary" type="submit"
                  onClick={e => this.handleSubmit(e)}
                  disabled={carregarShapes || clicked}>
                  {this.state.next ? t('forms.synchronize') : t('forms.save') }
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(CrudEdit);